import React, { memo, useEffect, useRef } from 'react';
import TagManager from 'react-gtm-module';
import { useLocation } from 'react-router-dom';
import { useScrollTracker } from 'react-scroll-tracker';

const TRACKED_SCROLL_DEPTHS = [25, 50, 75, 90, 100];

const ScrollEventCapture = () => {
  const emittedValuesRef = useRef<number[]>([]);

  useScrollTracker(TRACKED_SCROLL_DEPTHS, ({ scrollY }) => {
    const isValidScrollValue = TRACKED_SCROLL_DEPTHS.includes(scrollY);

    if (!isValidScrollValue) console.error(`The ${scrollY} scroll value is no a valid value.`);

    if (!emittedValuesRef.current.includes(scrollY) && isValidScrollValue) {
      const dataLayer = {
        event: 'trackEvent-scroll',
        event_name: 'scroll',
        percent_scrolled: scrollY,
      };
      TagManager.dataLayer({ dataLayer });
      emittedValuesRef.current = [...emittedValuesRef.current, scrollY];
    }
  });

  useEffect(
    () => () => {
      emittedValuesRef.current = [];
    },
    [],
  );

  return null;
};

const DataLayerScrollEvent = () => {
  const location = useLocation();

  return <ScrollEventCapture key={location.pathname} />;
};

export default memo(DataLayerScrollEvent);
